/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let appBase = window._env_.VUE_APP_SITE_HOST
export const getTaskTable = params => {
  return axios.post(`${base}/query_task`, params)
}
export const queryTaskTable = params => {
  return axios.post(`${base}/task/query`, params)
}
export const queryTaskArchivedTable = params => {
  return axios.post(`${base}/task/query_archived`, params)
}
export const getTaskDetail = params => {
  return axios.get(`${base}/task/get_${params.id}`, params)
}
export const createTaskData = params => {
  return axios.post(`${base}/create_task`, params)
}
export const updateTaskData = params => {
  return axios.post(`${base}/edit_task_${params.id}`, params)
}
export const batchPublish = params => {
  return axios.post(`${base}/task/bulk_publish`, params)
}
export const batchDelete = params => {
  return axios.post(`${base}/task/bulk_delete`, params)
}
export const copyTask = params => {
  return axios.post(`${base}/task/copy`, params)
}
export const batchCopyTask = params => {
  return axios.post(`${base}/task/bulk_copy`, params)
}
export const taskDelete = params => {
  return axios.post(`${base}/delete_task_${params.taskid}`, params)
}
export const taskPublishOnSearch = params => {
  return axios.post(`${base}/task/publish_search_result`, params)
}
export const getTaskPublishOnSearchInfo = params => {
  return axios.post(`${base}/task/publish_search_result_info`, params)
}
export const taskPublish = params => {
  return axios.post(`${base}/publish_task_${params.taskid}`, params)
}
export const exportTask = params => {
  return axios.post(`${base}/task/export`, params)
}
export const exportTaskArchived = params => {
  return axios.post(`${base}/task/export_archived`, params)
}
export const getCopyTaskInfo = params => {
  return axios.get(`${base}/task/copy_info_${params.id}`, params)
}
/**
 * 验证任务金额
 *
 * @param params
 * @param params.projectid
 * @param params.totalSalary
 * @returns {AxiosPromise<any>}
 */
export const checkTaskSalary = params => {
  return axios.post(`${base}/task/check_amount`, params)
}
export const uploadTaskFile = params => {
  return axios.post(`${base}/task/uploadfile`, params)
}
export const taskPreviewUrl = params => {
  return `${appBase}/index.html?page=/private/build8.1.3/modules/task-steps.js&isOpenThroughrecord=false&taskStepMode=preview_task&currentEndTime=&delaymins=&rfversion=1`
}
export const taskNearbyUsers = params => {
  return axios.post(`${base}/task/${params.taskid}/nearby_users`, params)
}

export const getMiDanTaskTable = params => {
  return axios.get(`${base}/midan/tasklist/${params.id}`, {params})
}

export const createTaskBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_create_task`, params)
}

export const createTaskWithTemplateBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_create_task_with_template`, params)
}

export const editTaskBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_update_task`, params)
}

export const deleteTaskBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_delete_task`, params)
}

export const reactivateTaskBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_reactivate_task`, params)
}

export const importTaskAuditReferenceBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_import_task_audit_reference`, params)
}

export const taskAvailableTimeBatchJob = params => {
  return axios.post(`${base}/batch_jobs/batch_set_task_available_time`, params)
}
export const exportUserCoverageApi = params => {
  return axios.post(`${base}/batch_jobs/export_user_coverage`, params)
}
export const suggestPriceCreateTaskApi = params => {
  return axios.post(`${base}/batch_jobs/suggest_price_create_task`, params)
}

// 地图相关
// post mapsearch/query_tasks
export const mapsearchQueryTasks = params => {
  return axios.post(`${base}/mapsearch/query_tasks`, params)
}

// mapsearch/query_users
export const mapsearchQueryUsers = params => {
  return axios.post(`${base}/mapsearch/query_users`, params)
}

// mapsearch/query_customers
export const mapsearchQueryCustomers = params => {
  return axios.post(`${base}/mapsearch/query_customers`, params)
}

// POST /admin/mapsearch/nearby/query_idcard_covered_users
export const mapsearchQueryIdcardCoveredUsers = params => {
  return axios.post(`${base}/mapsearch/nearby/query_idcard_covered_users`, params)
}

// POST /admin/mapsearch/nearby/query_order_covered_users
export const mapsearchQueryOrderCoveredUsers = params => {
  return axios.post(`${base}/mapsearch/nearby/query_order_covered_users`, params)
}

// POST /admin/mapsearch/query_tasks_map - 基于viewport的地图任务查询
export const mapsearchQueryTasksMap = params => {
  return axios.post(`${base}/mapsearch/query_tasks_map`, params)
}

// POST /admin/mapsearch/query_users_map - 基于viewport的地图用户查询
export const mapsearchQueryUsersMap = params => {
  return axios.post(`${base}/mapsearch/query_users_map`, params)
}



// WEBPACK FOOTER //
// ./src/views/task/task.api.js